import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Select Hound for Race ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" This is a special race. ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" You will need a hound with one of the following extra traits: ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" You will need a hound with the ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" extra trait. ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "USD", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" will be added to the entry fee. ")
const _hoisted_9 = {
  href: "https://docs.houndrace.com/",
  target: "_blank"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Learn more about fees")
const _hoisted_11 = { style: {"margin-right":"2rem"} }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Total Fee:")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "USD", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" The total fee includes the arena fee. ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("REGISTER IN RACE")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_circle_icon = _resolveComponent("circle-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_form = _resolveComponent("n-form")!

  return (_openBlock(), _createBlock(_component_n_form, {
    model: _ctx.formValue,
    ref: "formRef",
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.registerHound()), ["prevent"])),
    rules: _ctx.rules
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_card, {
        segmented: {
        footer: 'soft',
        content: true
      },
        closable: "",
        onClose: _ctx.cancel,
        size: _ctx.breakpoints.sDown.matches ? 'small' : 'medium'
      }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_n_space, { vertical: "" }, {
            default: _withCtx(() => [
              (_ctx.queue.speciesAllowed.length && !_ctx.queue.speciesAllowed.includes(0))
                ? (_openBlock(), _createBlock(_component_n_alert, {
                    key: 0,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      (_ctx.queue.speciesAllowed.filter(sa => sa !== 0).length > 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_3,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.queue.speciesAllowed.filter(sa => sa !== 0), (specie, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _createVNode(_component_n_icon, { style: {"margin-right":".25rem"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_circle_icon)
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.overrideInventory.find(item => item.overrideSpecie === specie).label), 1)
                              ]))
                            }), 128))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_4,
                            _createElementVNode("strong", null, _toDisplayString(_ctx.overrideInventory.find(item => item.overrideSpecie === _ctx.queue.speciesAllowed.filter(sa => sa !== 0)[0]).label), 1),
                            _hoisted_5
                          ], 64))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_n_alert, { type: "info" }, {
                default: _withCtx(() => [
                  _createTextVNode(" An additional " + _toDisplayString(_ctx.alphaDuneFeeInfo.amount) + " ", 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.alphaDuneFeeInfo.currencyName), 1),
                  (_ctx.exchangeRatesAvailable && _ctx.exchangeRates[_ctx.alphaDuneFeeInfo.currency])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" (" + _toDisplayString(_ctx.convertToUSD(_ctx.alphaDuneFeeInfo.amount, false, _ctx.alphaDuneFeeInfo.currency)) + " ", 1),
                        _hoisted_6,
                        _hoisted_7
                      ], 64))
                    : _createCommentVNode("", true),
                  _hoisted_8,
                  _createElementVNode("a", _hoisted_9, [
                    _createVNode(_component_n_text, { type: "info" }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        action: _withCtx(() => [
          _createVNode(_component_n_space, {
            align: "center",
            justify: "space-between"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_n_tooltip, {
                  trigger: "hover",
                  placement: "top-start"
                }, {
                  trigger: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_n_space, {
                        align: "center",
                        size: _ctx.exchangeRatesAvailable && _ctx.exchangeRates[_ctx.currencyId] ? 'medium' : [4, 4]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_text, null, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_n_space, {
                            vertical: "",
                            size: [1, 1]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_n_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.totalTicketFee) + " ", 1),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.currencyName), 1)
                                ]),
                                _: 1
                              }),
                              (_ctx.exchangeRatesAvailable && _ctx.exchangeRates[_ctx.currencyId])
                                ? (_openBlock(), _createBlock(_component_n_text, {
                                    key: 0,
                                    depth: "3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.convertToUSD(_ctx.totalTicketFee, false, _ctx.currencyId)) + " ", 1),
                                      _hoisted_13
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["size"])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_n_space, { justify: "right" }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_button, {
                    disabled: _ctx.loading,
                    type: "primary",
                    "attr-type": "submit",
                    loading: _ctx.loading
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_n_form_item, {
            label: "Hound",
            path: "hound"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_select, {
                disabled: _ctx.loading,
                class: "big-select",
                options: _ctx.houndOptions,
                value: _ctx.formValue.hound,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formValue.hound) = $event)),
                style: {"width":"100%"},
                "render-label": _ctx.renderLabel,
                "render-tag": _ctx.renderTag
              }, null, 8, ["disabled", "options", "value", "render-label", "render-tag"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClose", "size"])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}